import { SubscribeMembershipPlanEvent } from '../../event'

export function handleSubscribeMembershipPlan(event: SubscribeMembershipPlanEvent) {
  const { planId } = event
  window.dataLayer.push({
    event: 'subsc_purchase',
    plan_id: planId,
  })
}
